import {
  CooperatorUserRole,
  CreateFormInviteLinkMutation,
  CreateFormInviteLinkMutationVariables,
  DestroyAllFormInviteLinksMutation,
  DestroyAllFormInviteLinksMutationVariables,
  DestroyFormCooperatorMutation,
  DestroyFormCooperatorMutationVariables,
  GetFormCooperatorQuery,
  GetFormCooperatorQueryVariables,
  GetFormCooperatorsQuery,
  GetFormCooperatorsQueryVariables,
  GetFormInviteLinksQuery,
  GetFormInviteLinksQueryVariables,
  UpdateFormCooperatorMutation,
  UpdateFormCooperatorMutationVariables,
} from '@/typings/domain'
import apolloClient from './apolloClient'
import CreateFormInviteLinkGQL from './graphql/CreateFormInviteLink.graphql'
import DestroyAllFormInviteLinksGQL from './graphql/DestroyAllFormInviteLinks.graphql'
import DestroyFormCooperatorGQL from './graphql/DestroyFormCooperator.graphql'
import GetFormCooperatorGQL from './graphql/GetFormCooperator.graphql'
import GetFormCooperatorsGQL from './graphql/GetFormCooperators.graphql'
import GetFormInviteLinksGQL from './graphql/GetFormInviteLinks.graphql'
import UpdateFormCooperatorGQL from './graphql/UpdateFormCooperator.graphql'

export function getFormCooperators({ formToken, after, first }: GetFormCooperatorsQueryVariables) {
  return apolloClient.query<GetFormCooperatorsQuery, GetFormCooperatorsQueryVariables>({
    query: GetFormCooperatorsGQL,
    variables: {
      formToken,
      after,
      first,
    },
    fetchPolicy: 'no-cache',
  })
}

export function getFormCooperator({ formId, id }: GetFormCooperatorQueryVariables) {
  return apolloClient.query<GetFormCooperatorQuery, GetFormCooperatorQueryVariables>({
    query: GetFormCooperatorGQL,
    variables: {
      formId,
      id,
    },
    fetchPolicy: 'no-cache',
  })
}

export function updateFormCooperator(variables: UpdateFormCooperatorMutationVariables) {
  return apolloClient.mutate<UpdateFormCooperatorMutation, UpdateFormCooperatorMutationVariables>({
    mutation: UpdateFormCooperatorGQL,
    variables,
    fetchPolicy: 'no-cache',
  })
}

export function destroyFormCooperator(variables: DestroyFormCooperatorMutationVariables) {
  return apolloClient.mutate<DestroyFormCooperatorMutation, DestroyFormCooperatorMutationVariables>({
    mutation: DestroyFormCooperatorGQL,
    variables,
    fetchPolicy: 'no-cache',
  })
}

export function getFormInviteLinks(formToken: string) {
  return apolloClient.query<GetFormInviteLinksQuery, GetFormInviteLinksQueryVariables>({
    query: GetFormInviteLinksGQL,
    variables: { formToken },
    fetchPolicy: 'no-cache',
  })
}

export type CreateFormInviteLinkInput = {
  formToken: string
  formRoleId: string
  userRole: CooperatorUserRole
}

export function createFormInviteLink(input: CreateFormInviteLinkInput) {
  return apolloClient.mutate<CreateFormInviteLinkMutation, CreateFormInviteLinkMutationVariables>({
    mutation: CreateFormInviteLinkGQL,
    variables: { input: { id: input.formToken, formRoleId: input.formRoleId, userRole: input.userRole } },
    fetchPolicy: 'no-cache',
  })
}

export function destroyAllFormInviteLinks({ formToken }: { formToken: string }) {
  return apolloClient.mutate<DestroyAllFormInviteLinksMutation, DestroyAllFormInviteLinksMutationVariables>({
    mutation: DestroyAllFormInviteLinksGQL,
    variables: { input: { id: formToken } },
    fetchPolicy: 'no-cache',
  })
}
